import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

const URL = '/v2/sitter-search-infos';

export interface SitterSearchInfo {
  parentId: number;
  resultCount: number;
  sitterSearch: Record<string, unknown>;
}

class SitterSearchInfoService {
  static create(
    data: SitterSearchInfo,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SitterSearchInfo>> {
    return axios.post(URL, data, config);
  }
}

export { SitterSearchInfoService };
